module.exports = __webpack_public_path__ + "img/Streeme-logo_small_dark.60e699.png";